<template>
	<v-text-field v-bind="$attrs"
	              v-model="model"
	              @change="onModelUpdated"
	              type="text"
	              :rules="numberRules">
		<template #prepend>
			<slot name="prepend">
			</slot>
		</template>
		<template #append>
			<slot name="append">
			</slot>
		</template>
	</v-text-field>
</template>

<script lang="ts">
import {Component, Emit, Prop, Vue, Watch} from "vue-property-decorator";
import NumberHelper from "../services/numberHelper";

@Component
export default class NumberInput extends Vue {
	@Prop() value: any;
	@Prop() rules: any[];
	@Prop() min: number;
	@Prop() max: number;
	@Prop({type: Boolean, default: false}) required: boolean;
	@Prop({type: Boolean, default: false}) integer: boolean;

	@Emit() input() {
		return this.parseNumber(this.model);
	}

	model: string | number = null;

	get numberRules() {
		const rules = [this.$rules.number];
		if (this.min != null)
			rules.push(this.$rules.min(this.min));
		if (this.max != null)
			rules.push(this.$rules.max(this.max));
		if (this.required)
			rules.push(this.$rules.required);
		if (this.integer)
			rules.push(this.$rules.integer);
		return rules.concat(this.rules || []);
	}

	get numberGroupSeparator() {
		return this.$vopsui.options.numberGroupSeparator();
	}

	get numberDecimalSeparator() {
		return this.$vopsui.options.numberDecimalSeparator();
	}

	@Watch('value', {immediate: true})
	onValueUpdated(value) {
		const formatted = this.formatNumber(value);
		if (formatted == this.model)
			return;
		this.model = formatted;
	}

	onModelUpdated() {
		this.input();
	}

	private parseNumber(value: string | number) {
		if (value == null || value === '')
			return value;

		const n = NumberHelper.parseNumber(value, this.numberGroupSeparator, this.numberDecimalSeparator);
		return isNaN(n as any) ? value : n;
	}

	private formatNumber(value: any) {
		return NumberHelper.formatNumber(value);
	}
}
</script>